import { createStore, applyMiddleware, compose } from 'redux'
import { createBrowserHistory } from 'history'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './sagas'
import reducers from './reducers'
import thunk from 'redux-thunk'

let composeEnhancers = compose
if (process.env.NODE_ENV !== 'production') {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || composeEnhancers
}
export const history = createBrowserHistory()

const sagaMiddleware = createSagaMiddleware()
const middlewares = [thunk, sagaMiddleware]

const store = createStore(
  reducers(history),
  composeEnhancers(
    applyMiddleware(...middlewares)
  )
)

sagaMiddleware.run(rootSaga)

export default store
